import { DollarOutlined, PropertySafetyOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { useCallback, useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

const Overview = () => {
  const [overviewPTO, setOverviewPTO] = useState<any>({})
  const [loading, setLoading] = useState(false)

  const getDataTable = useCallback(async () => {
    try {
      const res = await AppAdmin.getPTOOverview()
      if (res?.data.success) {
        setOverviewPTO(res?.data?.data)
      }
    } catch (err) {
      logError(err)
    }
  }, [])

  const getDataFirstTime = useCallback(async () => {
    setLoading(true)
    try {
      await getDataTable()
    } catch (err) {
      logError(err)
    } finally {
      setLoading(false)
    }
  }, [getDataTable])

  useEffect(() => {
    getDataFirstTime()
  }, [getDataFirstTime])

  return (
    <div className="dashboard-container">
      <div className="wrap-dashboard">
        <div className="wrap-box">
          <div className="title">PTO Overview</div>
          <div className="wrap-columns">
            <div className="columns">
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">NFT Supply</div>
                      <div className="number">
                        {loading ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(
                            overviewPTO?.totalTokenizeSupply || 0
                          )
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <PropertySafetyOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Total NFT sold</div>
                      <div className="number">
                        {loading ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(overviewPTO?.totalTokenizeSold || 0)
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <PropertySafetyOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Total Funding Target (USDC)</div>
                      <div className="number">
                        {loading ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(
                            overviewPTO?.totalFundingTarget || 0
                          )
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <DollarOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colum w-3">
                <div className="guide-box">
                  <div className="box-content">
                    <div className="left-s">
                      <div className="txt">Total NFT Claimed</div>
                      <div className="number">
                        {loading ? (
                          <Spin />
                        ) : (
                          new Intl.NumberFormat('en-US').format(overviewPTO?.totalTokenizeClaimed)
                        )}
                      </div>
                    </div>
                    <div className="right-s">
                      <div className="icon">
                        <DollarOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Overview
